import * as zod from 'zod';

import { DHState } from '@sb/integrations/implementations/dh/comon/types/DHState';

export const DHAG105145State = DHState.extend({
  kind: zod.literal('DHAG105145'),
});

export type DHAG105145State = zod.infer<typeof DHAG105145State>;
